import {
    CATEGORY_DATA_RECEIVED,
    CATEGORY_LOADER,
    SERVICE_DATA_RECEIVED,
    PROVIDER_DATA_RECEIVED,
    PROVIDER_LOADER,
    PROVIDER_SERVICE_LOADER,
    PROVIDER_SERVICE_DATA_RECEIVED,
    SERVICE_LOADER
} from './types';
import {
    categoryList,
    mainSearch,
    allServices,
    providerServiceList,
    getProviderServices,
    serviceChangeStatus,
    getCategoryService,
    addService,
    uploadServicePhoto,
    providerServiceDetail,
    updateProviderService,
    addServiceFaq,
    serviceFaqDetail,
    updateServiceFaq,
    deleteServiceFaq,
    addServicePackage,
    updateServicePackage,
    servicePackageDetail,
    deleteServicePackage,
    addServiceGalleryImage,
    providerServiceVideoList,
    addVideoUrl,
    deleteServiceVideoUrl,
    updateVideoUrl,
    providerServiceVideoDetail,
    providerCategoryList,
    providerSearchList,
    serviceList,
    topServiceList,
    topCategory,
    providerMainSearchList,
    mastercategoryList,
    checkService
} from '../apiHelpers/category/list';

import { serviceProviderList } from '../apiHelpers/provider/list';

export const masterCategoryAction = () => async dispatch => {
    try {
        dispatch({ type: CATEGORY_LOADER, payload: true });
        const response = await mastercategoryList();
        if (response.status == 'OK') {
            dispatch({ type: CATEGORY_DATA_RECEIVED, payload: response.data });
            dispatch({ type: CATEGORY_LOADER, payload: false });
        }
    } catch (e) {
        console.log('Error found in all category');
    }
};

export const allCategoryAction = () => async dispatch => {
    try {
        dispatch({ type: CATEGORY_LOADER, payload: true });
        const response = await categoryList();
        if (response.status == 'OK') {
            dispatch({ type: CATEGORY_DATA_RECEIVED, payload: response.data });
            dispatch({ type: CATEGORY_LOADER, payload: false });
        }
    } catch (e) {
        console.log('Error found in all category');
    }
};

// export const masterCategoryAction = (done) => async dispatch => {
//     try {
//         const response = await mastercategoryList();
//         if (response.status == 'OK') {
//             done(response.data)
//         }
//     } catch (e) {
//         console.log('Error found in all category');
//     }
// };

export const topCategoryAction = () => async dispatch => {
    try {
        dispatch({ type: CATEGORY_LOADER, payload: true });
        const response = await topCategory();
        if (response.status == 'OK') {
            dispatch({ type: CATEGORY_DATA_RECEIVED, payload: response.data });
            dispatch({ type: CATEGORY_LOADER, payload: false });
        }
    } catch (e) {
        console.log('Error found in all category');
    }
};
export const allProviderCategoryAction = () => async dispatch => {
    try {
        dispatch({ type: CATEGORY_LOADER, payload: true });
        const response = await providerCategoryList();
        if (response.status == 'OK') {
            // done(true, response);
            dispatch({ type: CATEGORY_DATA_RECEIVED, payload: response.data });
            dispatch({ type: CATEGORY_LOADER, payload: false });
        } else {
            dispatch({ type: CATEGORY_LOADER, payload: false });
            //done(false, response);
        }
    } catch (e) {
        console.log({ e });
        console.log('Error found in all category');
    }
};

export const providerSearchListAction = (params, done) => async dispatch => {
    try {
        const response = await providerSearchList(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        console.log('Error found in all category');
    }
};

export const providerMainSearchListAction = (
    params,
    done
) => async dispatch => {
    try {
        const response = await providerMainSearchList(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        console.log('Error found in all category');
    }
};

export const mainSearchAction = (params, done) => async dispatch => {
    try {
        const response = await mainSearch(params);
        if (response.status == 'OK') {
            dispatch({ type: PROVIDER_DATA_RECEIVED, payload: response.data });

            done(true, response);
        } else {
            done(true, response);
        }
    } catch (e) {
        done(false, 'Something error');
    }
};

export const allServicesAction = () => async dispatch => {
    try {
        dispatch({ type: CATEGORY_LOADER, payload: true });
        const response = await allServices();
        if (response.status == 'OK') {
            dispatch({ type: SERVICE_DATA_RECEIVED, payload: response.data });
            dispatch({ type: CATEGORY_LOADER, payload: false });
        }
    } catch (e) {
        console.log('Error found in allServicesAction');
    }
};

export const serviceListAction = done => async dispatch => {
    try {
        const response = await serviceList();

        if (response.status == 'OK') {
            done(true, response);
        }
    } catch (e) {
        done(true, e);
        console.log('Error found in Service List Action');
    }
};

export const providerServiceListAction = (params, done) => async dispatch => {
    try {
        const response = await providerServiceList(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(true, response);
        }
    } catch (e) {
        done(false, 'Something error');
    }
};
export const serviceProviderListAction = (params, done) => async dispatch => {
    try {
        const response = await serviceProviderList(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(true, response);
        }
    } catch (e) {
        done(false, 'Something error');
    }
};

export const getProviderServicesAction = params => async dispatch => {
    try {
        const response = await getProviderServices(params);

        if (response.status == 'OK') {
            dispatch({
                type: PROVIDER_SERVICE_DATA_RECEIVED,
                payload: response.data
            });
            dispatch({ type: PROVIDER_SERVICE_LOADER, payload: false });
            return true;
        } else {
            dispatch({ type: PROVIDER_SERVICE_LOADER, payload: false });
            return false;
        }
    } catch (e) {
        console.log({ e });
        return false;
    }
};

export const getProviderServiceAction = (params, done) => async dispatch => {
    try {
        const response = await getProviderServices(params);
        if (response.status == 'OK') {
            return done(true, response);
        } else {
            return done(false, response);
        }
    } catch (e) {
        console.log({ e });
        return false;
    }
};
export const serviceChangeStatusAction = (params, done) => async dispatch => {
    try {
        const response = await serviceChangeStatus(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Something error');
    }
};
export const getCategoryServiceAction = (params, done) => async dispatch => {
    try {
        const response = await getCategoryService(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Something error');
    }
};

export const addServiceAction = (params, done) => async dispatch => {
    try {
        const response = await addService(params);
        if (response.status == 'OK') {
            dispatch(getProviderServicesAction());
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Something error');
    }
};

export const updateProviderServiceAction = (params, done) => async dispatch => {
    try {
        const response = await updateProviderService(params);
        if (response.status == 'OK') {
            dispatch(getProviderServicesAction());
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};

// export const uploadServicePhotoAction = (params, done) => async dispatch => {
//     try {
//         const response = await uploadServicePhoto(params);
//         if (response.status === 'OK') {
//             return done(true, response.message);
//         }
//         return done(false, response.message);
//     } catch (e) {
//         done(false, 'Something error');
//     }
// };
export const providerServiceDetailAction = (params, done) => async dispatch => {
    try {
        const response = await providerServiceDetail(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};
export const addServiceFaqAction = (params, done) => async dispatch => {
    try {
        const response = await addServiceFaq(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};
export const addServicePackageAction = (params, done) => async dispatch => {
    try {
        const response = await addServicePackage(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};

export const updateServiceFaqAction = (params, done) => async dispatch => {
    try {
        const response = await updateServiceFaq(params);
        if (response.status == 'OK') {
            dispatch(getProviderServicesAction());
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};
export const updateServicePackageAction = (params, done) => async dispatch => {
    try {
        const response = await updateServicePackage(params);
        if (response.status == 'OK') {
            dispatch(getProviderServicesAction());
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};

export const serviceFaqDetailAction = (params, done) => async dispatch => {
    try {
        const response = await serviceFaqDetail(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};
export const servicePackageDetailAction = (params, done) => async dispatch => {
    try {
        const response = await servicePackageDetail(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};

export const deleteServiceFaqAction = (params, done) => async dispatch => {
    try {
        const response = await deleteServiceFaq(params);
        if (response.status == 'OK') {
            dispatch(getProviderServicesAction());
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};
export const deleteServicePackageAction = (params, done) => async dispatch => {
    try {
        const response = await deleteServicePackage(params);
        if (response.status == 'OK') {
            dispatch(getProviderServicesAction());
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};
export const addServiceGalleryImageAction = (
    params,
    done
) => async dispatch => {
    try {
        const response = await addServiceGalleryImage(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};
export const providerServiceVideoListAction = (
    params,
    done
) => async dispatch => {
    try {
        const response = await providerServiceVideoList(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};

export const providerServiceVideoDetailAction = (
    params,
    done
) => async dispatch => {
    try {
        const response = await providerServiceVideoDetail(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};

export const addVideoUrlAction = (params, done) => async dispatch => {
    try {
        const response = await addVideoUrl(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};
export const updateVideoUrlAction = (params, done) => async dispatch => {
    try {
        const response = await updateVideoUrl(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        console.log(e);
        done(false, 'Unknown Error Occurred');
    }
};

export const deleteServiceVideoUrlAction = (params, done) => async dispatch => {
    try {
        const response = await deleteServiceVideoUrl(params);
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};

export const topServiceListAction = done => async dispatch => {
    try {
        const response = await topServiceList();
        if (response.status == 'OK') {
            done(true, response);
        } else {
            done(false, response);
        }
    } catch (e) {
        done(false, 'Unknown Error Occurred');
    }
};


export const checkServiceAction = (params, done) => async dispatch => {
    try {
        const response = await checkService(params);
        if(response.status == 'OK'){
            return done(true);
        }else{
            return done(false);
        }
        
    } catch (error) {
        done(false, 'Unknown Error Occurred');
    }
}


// WEBPACK FOOTER //
// ./src/actions/Category.js